import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { apiConstant } from '../app.constant';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ActivityLogsService {

  public baseUrl = `${environment.baseUrl}`;

  constructor(private http: HttpClient) { }

  getActivityLogs(page: number, filters: any = {}) {
    let apiUrl = this.baseUrl + apiConstant.ACTIVITY_LOGS + '?page=' + page;

    if (filters.search) {
      apiUrl += '&search=' + filters.search;
    }
    if (filters.action) {
      apiUrl += '&action=' + filters.action;
    }
    if (filters.date) {
      apiUrl += '&date=' + filters.date;
    }
    if (filters.month) {
      apiUrl += '&month=' + filters.month;
    }
    if (filters.year) {
      apiUrl += '&year=' + filters.year;
    }

    return this.http.get<any>(apiUrl);
  }

  getActionLabels() {
    return this.http.get<any>(this.baseUrl + apiConstant.ACTIVITY_LOGS + '/actions');
  }

  logPageVisit(page: string) {
    return this.http.post<any>(this.baseUrl + apiConstant.ACTIVITY_LOGS + '/page-visit', { page });
  }
}
